import type {
  DownlineNodeDto,
  TeamLevelDto,
  TeamMemberInstallmentsDto,
  TeamMemberProfileDto,
  TeamSearchResultDto,
} from '../../domain/contracts/api.contracts';
import { apiClient } from './apiClient';
import { normalizeMoney, teamFromWire } from './wireAdapters';

/** E06 — GET /hierarchy/downline (L2+; 403 for L1). */
export async function getDownline(): Promise<DownlineNodeDto[]> {
  const { data } = await apiClient.get<DownlineNodeDto[]>('/hierarchy/downline');
  return normalizeMoney(data);
}

// --- E22–E25 Team Navigator & Member 360 (PRD v1.6.0 §7.5.1) ---

export interface TeamLevelParams {
  tier?: string;
  status?: string;
  sort?: string;
  page?: number;
  limit?: number;
}

/** E22 — GET /hierarchy/members/:userId/children (`me` = the viewer). */
export async function getTeamLevel(userId: string, params: TeamLevelParams): Promise<TeamLevelDto> {
  const query = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== 'ALL'));
  const { data } = await apiClient.get<TeamLevelDto>(`/hierarchy/members/${encodeURIComponent(userId)}/children`, { params: query });
  return teamFromWire(data);
}

/** E23 — GET /hierarchy/members/:userId (404 outside the viewer's subtree). */
export async function getTeamMember(userId: string): Promise<TeamMemberProfileDto> {
  const { data } = await apiClient.get<TeamMemberProfileDto>(`/hierarchy/members/${encodeURIComponent(userId)}`);
  return teamFromWire(data);
}

/** E24 — GET /hierarchy/members/:userId/installments (read-only). */
export async function getTeamMemberInstallments(userId: string, subscriptionId?: string): Promise<TeamMemberInstallmentsDto> {
  const { data } = await apiClient.get<TeamMemberInstallmentsDto>(
    `/hierarchy/members/${encodeURIComponent(userId)}/installments`,
    { params: subscriptionId ? { subscriptionId } : undefined },
  );
  return teamFromWire(data);
}

/** E25 — GET /hierarchy/search (q ≥ 2 chars). */
export async function searchTeam(q: string): Promise<TeamSearchResultDto[]> {
  const { data } = await apiClient.get<TeamSearchResultDto[]>('/hierarchy/search', { params: { q, limit: 10 } });
  return teamFromWire(data);
}
